<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crmid"/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>佣金列表</span>
          </div>
          <div class="searchList">
            <div class="box-content">
              <label class="form-tit">所属部门</label>
              <el-select
                class="jm-input280"
                v-model="searchData.department_id"
                clearable
                placeholder="请选择">
                <el-option label="芥末留学" :value="12"/>
                <el-option label="前程日本" :value="13"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">合作方</label>
              <el-input
                v-model="searchData.partner_name"
                clearable
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">发起人</label>
              <el-input
                v-model="searchData.creator_name"
                clearable
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">费用类型</label>
              <el-select
                class="jm-input280"
                v-model="searchData.commission_kind"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.commission_type"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">外币种类</label>
              <el-select
                class="jm-input280"
                v-model="searchData.currency_type"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.currency_type"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">收款账户</label>
              <el-select
                class="jm-input280"
                v-model="searchData.payment_method"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.payment_method"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">收款时间</label>
              <el-date-picker
                class="jm-input280"
                v-model="searchData.receive_time"
                clearable
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </div>
            <div class="box-content">
              <label class="form-tit">支付金额</label>
              <div style="display:inline-block;width:290px">
                <el-input
                  placeholder="起始金额"
                  class="jm-input135"
                  clearable
                  v-model="searchData.total_amount[0]">
                </el-input>
                <el-input
                  placeholder="结束金额"
                  class="jm-input135"
                  clearable
                  v-model="searchData.total_amount[1]">
                </el-input>
              </div>
            </div>
            <div class="box-content">
              <label class="form-tit">审核状态</label>
              <el-select
                class="jm-input280"
                v-model="searchData.finance_status"
                clearable
                placeholder="请选择">
                <el-option label="待补全" :value="-1"/>
                <el-option label="未确认" :value="0"/>
                <el-option label="审核通过" :value="1"/>
                <el-option label="已拒绝" :value="2"/>
              </el-select>
            </div>
            <!-- <div class="box-content">
                  <label class="form-tit">财务备注</label>
                  <el-input
                    v-model="searchData.finance_message"
                    class="jm-input280"/>
                </div> -->
            <div class="box-content">
              <label class="form-tit">到账日期</label>
              <el-date-picker
                class="jm-input280"
                v-model="searchData.verify_time"
                clearable
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="box-content box-content-double">
              <label class="form-tit">报账时间</label>
              <el-date-picker
                class="jm-input500"
                v-model="searchData.update_time"
                clearable
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </div>
          </div>
          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="() => this.$store.commit('updateRefresh', true)">搜索</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields">重置</el-button>
            <el-button
              class="jm-input-common3"
              type="success"
              @click="exportDetails"
              :loading="btnLoading">导出明细</el-button>
          </div>
          <!--列表部分 start -->
          <jm-tableList
            :url="getListurl"
            :search-data="searchData"
          >
            <div name="perfix" slot="perfix" slot-scope="perfix" class="money-end-wrap">
              <el-row>
                <el-col :span="24">
                  <a href="javascript:void(0)">
                    <b>芥末总额：{{ perfix.data.totalAmountJiemo }}</b>
                    &nbsp; &nbsp;
                    <b>前程总额：{{ perfix.data.totalAmountQcrb }}</b>
                  </a>
                </el-col>
              </el-row>
            </div>
            <el-table-column
              slot="finance_file"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              width="150"
            >
              <template slot-scope="scope">
                <span v-for="(file, key) in scope.row.finance_file" :key="key" class="column-file">
                  <i v-if="checkImageUrl(file.url)" :title="file.name" class="el-icon-picture" @click="previewImage(file)" />
                  <i v-else :title="file.name" class="el-icon-document" @click="downloadFile(file)" />
                </span>
              </template>
            </el-table-column>
            <el-table-column
              slot="partner_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="250"
                  trigger="hover">
                  {{ scope.row.partner_name }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.partner_name }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="payment_method_str"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="250"
                  trigger="hover">
                  {{ scope.row.payment_method_str }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.payment_method_str }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="verify_message"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="250"
                  trigger="hover">
                  {{ scope.row.verify_message }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.verify_message }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="commission_memo"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="250"
                  trigger="hover">
                  {{ scope.row.commission_memo }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.commission_memo }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="finance_status_str"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="props">
                <el-tag :type="tagColors[props.row.finance_status]">{{ props.row.finance_status_str }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              slot="finance_message"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="props">
                <el-tooltip popper-class="table-tooltip-area" effect="dark" :content="props.row.finance_message" placement="left">
                  <span>{{ props.row.finance_message }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              slot="lastColumn"
              fixed="right"
              align="center"
              header-align="center"
              width="200"
              label="操作">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{ name: 'commissionEdit', params: { id:scope.row.id }}">
                  <el-button type="danger" size="small" v-if="scope.row.finance_status === -1">
                    补全报账
                  </el-button>
                  <el-button type="danger" size="small" v-if="scope.row.finance_status === 0">
                    编辑
                  </el-button>
                  <el-button type="primary" size="small" v-if="scope.row.finance_status === 1">
                    查看详情
                  </el-button>
                  <el-button type="success" size="small" v-if="scope.row.finance_status === 2">
                    修改报账
                  </el-button>
                </router-link>
              </template>
            </el-table-column>
          </jm-tableList>
          <!--列表部分 end-->
        </div>
      </div>
    </div>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="fileImageDialogVisible" :width="fileImageWidth" :show-close="false" custom-class="imagePreview">
      <img :src="fileImageUrl" :title="fileImageName" width="100%" />
    </el-dialog>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';
import { formatCurrency, checkImageUrl } from '@/utils/utils';

const tagColors = {
  2: 'danger',
  1: 'success',
  0: 'warning',
};

export default {
  data() {
    return {
      tagColors,
      searchData: {
        partner_id: '',
        partner_name: '',
        creator_name: '',
        commission_kind: '',
        department_id: '',
        currency_type: '',
        project_id: 1213,
        payment_method: '',
        total_amount: ['', ''],
        finance_status: '',
        receive_time: [],
        update_time: [],
        verify_time: [],
      },
      getListurl: '/index/commission/pagetable', // 表格数据源
      selectDict: {}, // 下拉框字典
      btnLoading: false,
      currencyUnit: 1, // 总额单位
      /* 图片预览 */
      fileImageDialogVisible: false,
      fileImageUrl: '',
      fileImageName: '',
      fileImageWidth: '65%'
    };
  },
  computed: {
  },
  methods: {
    // 获取页面数据
    getPageData() {
      this.$http
        ._post({
          url: '/finance/commission/searchDs'
        })
        .then((res) => {
          this.selectDict = res.data;
        });
    },
    // 重置搜索
    resetFields() {
      Object.keys(this.searchData).forEach((k) => {
        this.searchData[k] = '';
      });
      this.searchData.total_amount = [];
      this.$store.commit('updateRefresh', true);
    },
    // 导出明细
    exportDetails() {
      this.btnLoading = true;
      this.$http
        ._post({
          url: '/index/commission/downloadExcel',
          data: { searchData: this.searchData }
        })
        .then(({ data }) => {
          this.$http._download({
            filename: data,
            download: '佣金明细.xlsx'
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    handelUploadPreview(file) {
      if (!checkImageUrl(file.url)) {
        this.downloadFile(file);
      } else {
        this.previewImage(file);
      }
    },
    // 文件类型
    checkImageUrl(fileUrl) {
      return checkImageUrl(fileUrl);
    },
    // 下载文件
    downloadFile(file) {
      this.$message.success(`附件"${file.name}"下载完成`);
      this.$http.getFile({
        url: file.url,
        filename: file.name
      });
    },
    // 预览图片
    previewImage(file) {
      this.fileImageDialogVisible = true;
      this.fileImageName = file.name;
      this.fileImageUrl = file.url;
      this.fileImageWidth = '60%';
    },
    // 价格格式化
    formatCurrency(price) {
      return formatCurrency(price);
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList
  },
  mounted() {
    this.getPageData();
  }
};
</script>
<style scoped>
  .column-file {
    font-size:32px;
    color:#26D49B;
    cursor: pointer;
  }
</style>
<style>
  .el-upload--picture-card{
    width: 120px;
    height: 120px;
    line-height: 118px;
  }
  .el-upload-list--picture-card .el-upload-list__item{
    width: 120px;
    height: 120px;
  }
  /* 图片预览 */
  .imagePreview .el-dialog__header {
    display: none;
  }
  .imagePreview .el-dialog__body {
    padding: 2px;
  }
</style>
